import React from "react";
import styled from "styled-components";
import { ResponsibilitiesProps as Props } from ".";
import { Title } from "../Title";
import { List } from "../List";
import { Box } from "../Box";

export const Div = styled.div`
  display: inline-block;
`;

export const Responsibilities: React.FC<Props> = ({ title, lists }) => {
  return (
    <Box data-testid="responsibilities">
      <Title as="h2" mb={["16px", "24px"]}>
        {title}
      </Title>
      {lists &&
        lists.map(list => (
          <Box key={list.title} mb={["32px", "40px"]}>
            <List {...list} />
          </Box>
        ))}
    </Box>
  );
};
